import React from 'react';

import { DatePicker, Space } from 'antd/es';
import type { Dayjs } from 'dayjs';
import { Field, FormikProps } from 'formik';

import '@app/scss/components/customDatePicker.scss';

interface CustomDatePickerProps {
	placeholder: string;
	formikBag: FormikProps<any>;
	name: string;
	onChange: (value: Dayjs | null, dateString: string | Array<string>) => void;
	initValue?: Dayjs | null;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
	placeholder,
	formikBag,
	name,
	onChange,
	initValue,
}) => {
	const dateFormat = ['MM/DD/YYYY', 'MM-DD-YYYY', 'MM.DD.YYYY'];

	return (
		<Field
			name={name}
		>
			{(field) => {
				return (
					<div
						className={`custom-field custom-date-picker ${
							formikBag.errors[name] && formikBag.touched[name] ? 'error' : ''
						} ${
							typeof formikBag.values[name] === 'number' || formikBag.values[name]?.length ? 'focused' : ''
						}`}
					>
						<Space direction="vertical" size={12}>
							<DatePicker
								defaultValue={initValue}
								placeholder={placeholder}
								format={dateFormat}
								onChange={onChange}
								onBlur={() => field.form.setFieldTouched(name, true)}
							/>
						</Space>
						{formikBag.errors[name] && formikBag.touched[name] ? (
							<div className="custom-input__error">
								{formikBag.errors[name]}
							</div>
						) : null}
						<div className="custom-field__placeholder-top">{placeholder}</div>
					</div>
				);
			}}
		</Field>
	);
};

export default CustomDatePicker;
